import React, { Fragment } from "react";
import styled from "styled-components";
import _ from "lodash";
import { connect } from "formik";
import { Grid } from "@material-ui/core";
import num from "numeral";
import { AutoCompleteInput, MoneyInput } from "components/Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const StyledAutoCompleteInput = styled(AutoCompleteInput)`
&&&&{
  height:33px;
}
`;

const SideLabelMoneyWithSelectListInput = ({ label, fieldName, moneyFieldName, ddlFieldName, moneyPlaceholder, formik, isDisabled, hasBorder, options, selectName, selectValue, shouldHideForQuote, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  const { values } = formik;
  if (!selectName) {
    selectName = "name";
  }
  const valMoney = _.get(formik.values, moneyFieldName);
  const val = _.get(formik.values, ddlFieldName);
  let selectVal = _.find(options, { [selectValue]: val });

  if (!selectVal) {
    selectVal = { [selectName]: "--" };
  }

  return (
    <LateralField label={label} hasBorder={hasBorder}>
      {isDisabled && (
        <Grid container item spacing={16}>
          <Grid item xs={6}>
            <ViewOnlyDiv>{valMoney ? num(valMoney).format("$0,0") : ""}</ViewOnlyDiv>
          </Grid>
          <Grid item xs={6}>
            <div />
          </Grid>
        </Grid>
      )}

      {!isDisabled && (
        <Grid container item spacing={16}>
          <Grid item xs={4}>
            <MoneyInput
              fullWidth
              fieldName={moneyFieldName}
              placeholder={moneyPlaceholder}
              {...otherProps}
            />
          </Grid>
          <Grid item xs={8}>
            <StyledAutoCompleteInput
              formik={formik}
              id={`dropdownFor${label.replace(new RegExp(" ", "g"), "")}`}
              fieldName={ddlFieldName}
              options={options}
              selectName={selectName}
              selectValue={selectValue}
              {...otherProps}
            />
          </Grid>
        </Grid>
      )}
    </LateralField>
  );
};
export default connect(SideLabelMoneyWithSelectListInput);
